// Площадь полигона по гео-координатам [[lat,lng],...] — сферическая аппроксимация, м².
const EARTH_R = 6378137

export function polygonAreaSqM (latLngs) {
  if (!latLngs || latLngs.length < 3) return 0
  const rad = (d) => (d * Math.PI) / 180
  let sum = 0
  for (let i = 0; i < latLngs.length; i++) {
    const [lat1, lng1] = latLngs[i]
    const [lat2, lng2] = latLngs[(i + 1) % latLngs.length]
    sum += rad(lng2 - lng1) * (2 + Math.sin(rad(lat1)) + Math.sin(rad(lat2)))
  }
  return Math.abs((sum * EARTH_R * EARTH_R) / 2)
}

export function areaLabel (latLngs) {
  const m2 = Math.round(polygonAreaSqM(latLngs))
  return m2 >= 100000 ? (m2 / 1e6).toFixed(1) + ' км²' : m2.toLocaleString('ru') + ' м²'
}

export function polygonCenter (latLngs) {
  if (!latLngs || !latLngs.length) return [56.83, 60.6]
  const s = latLngs.reduce((a, p) => [a[0] + p[0], a[1] + p[1]], [0, 0])
  return [s[0] / latLngs.length, s[1] / latLngs.length]
}

// Склонение «зона» (дизайн-спека §10.3)
export function zonesPlural (n) {
  const m10 = n % 10
  const m100 = n % 100
  if (m10 === 1 && m100 !== 11) return n + ' зона'
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return n + ' зоны'
  return n + ' зон'
}

// PolygonResource.area (GeoJSON, [lng,lat]) → [[lat,lng],...]
export function areaToLatLngs (area) {
  if (!area || !area.coordinates || !area.coordinates[0]) return []
  return area.coordinates[0].map(([lng, lat]) => [lat, lng])
}

// обратно: [[lat,lng],...] → PolygonResource.area (GeoJSON, [lng,lat])
export function pointsToArea (points) {
  return { type: 'Polygon', coordinates: [points.map(([lat, lng]) => [lng, lat])] }
}

/**
 * Прямоугольник, накрывающий все вершины зон: [[minLat, minLng], [maxLat, maxLng]].
 * Формат ymaps map.setBounds при coordorder latlong. Пустой список → null.
 */
export function zonesBounds (zones) {
  let minLat = Infinity
  let minLng = Infinity
  let maxLat = -Infinity
  let maxLng = -Infinity
  zones.forEach((z) => {
    (z.latLngs || []).forEach(([lat, lng]) => {
      if (lat < minLat) minLat = lat
      if (lat > maxLat) maxLat = lat
      if (lng < minLng) minLng = lng
      if (lng > maxLng) maxLng = lng
    })
  })
  return minLat === Infinity ? null : [[minLat, minLng], [maxLat, maxLng]]
}
